import { useEffect, useRef, useState } from "react";
import Button from "../../../Custom/Button/Button";
import CustomSelect from "./CustomSelect";
import { useGlobalContext } from "../../../../Context/Context";
import scanImg from "../../../../picture/scan.png";
import CustomCalendarInput from "../evidencije/CustomCalendarInput";
import axios from "axios";
import FullScreenLoader from "../../FullScreenLoader/FullScreenLoader";

// DODATI NOVI SEGMENTI: Izmena i Dopuna
const segmentiAllMock = [
  {
    id: "1",
    name: "Акт о процени ризика",
    dbValue: "Akt o proceni rizika",
    type: "AKT"
  },
  { id: "2", name: "Одлука", dbValue: "Odluka", type: "AKT" },
  { id: "3", name: "Изјава", dbValue: "Izjava", type: "AKT" },
  {
    id: "4",
    name: "Оверена задња страна",
    dbValue: "Overena zadnja strana",
    type: "AKT"
  },
  { id: "12", name: "Измена", dbValue: "Izmena", type: "AKT" },
  { id: "13", name: "Допуна", dbValue: "Dopuna", type: "AKT" },
  {
    id: "14",
    name: "Програм обуке",
    dbValue: "Program osposobljavanja",
    type: "AKT"
  },
  { id: "15", name: "Правилник", dbValue: "Pravilnik", type: "AKT" },
  {
    id: "5",
    name: "Упутство за пружање ПП",
    dbValue: "Uputstvo za pruzanje PP",
    type: "PRVA_POMOC"
  },
  {
    id: "6",
    name: "Шема ормарића",
    dbValue: "Sema ormarica",
    type: "PRVA_POMOC"
  },
  {
    id: "7",
    name: "Списак обучених за ПП",
    dbValue: "Spisak obucenih za pruzanje PP",
    type: "PRVA_POMOC"
  },
  {
    id: "8",
    name: "Остала упутства",
    dbValue: "Ostala uputstva",
    type: "PRVA_POMOC"
  }
];

const radnaMestaAllMock = [
  { id: "1", name: "Direktor" },
  { id: "2", name: "Vozac motornog vozila" },
  { id: "3", name: "Cistacica" },
  { id: "4", name: "Automehanicar za teretna vozila" }
];

const nowDate = new Date()
  .toLocaleDateString("sr-RS", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit"
  })
  .replaceAll("/", ".")
  .slice(0, -1);

const dokumentEmpty = {
  segment: { id: -1, name: "", type: "" },
  nazivDokumenta: "",
  brojDokumenta: "",
  datum: nowDate,
  scan: false,
  radnoMesto: { id: -1, name: "" }
};

const getFileName = (file) => {
  if (!file) return "";
  const lastDot = file.name.lastIndexOf(".");
  if (lastDot === -1) return file.name;
  return file.name.slice(0, lastDot);
};

const styles = { button: { padding: "10px", fontWeight: "bold" } };

const mapProcenaRizika = {
  1: "AKT",
  3: "PRVA_POMOC",
  6: "SISTEMATIZACIJA_RADNIH_MESTA"
};

function ProcenaRizikaForm({ fileNewDocument }) {
  const [dokument, setDokument] = useState(dokumentEmpty);
  const [segmenti, setSegmenti] = useState([]);
  const [isDodajNoviText, setIsDodajNoviText] = useState(false);
  const [fileDocument, setFileDocument] = useState(fileNewDocument);
  const [radnaMestaAll, setRadnaMestaAll] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const {
    dictionary,
    setIsGlobalnoDodavanjeDokumenta,
    selectedProcenaRizika,
    sisRadnihMestaDokumentaId,
    baseUrl,
    selectedMainEntity,
    loggedUser,
    apiKey
  } = useGlobalContext();

  const company_id = selectedMainEntity?.company_id;
  const fileInputRef = useRef();

  const isPrvaPomoc = 
    selectedProcenaRizika === 3 ||
    dokument.segment.type === "PRVA_POMOC";

  const isSistematizacijaRadnihMesta =
    selectedProcenaRizika === 6 ||
    dokument.segment.type === "SISTEMATIZACIJA_RADNIH_MESTA";

  useEffect(() => {
    setDokument((prev) => ({
      ...prev,
      nazivDokumenta: getFileName(fileNewDocument)
    }));
    setFileDocument(fileNewDocument);
  }, [fileNewDocument]);

  useEffect(() => {
    if ([1, 3, 6].includes(selectedProcenaRizika)) {
      setSegmenti(
        segmentiAllMock.filter(
          (s) => s.type === mapProcenaRizika[selectedProcenaRizika]
        )
      );
      return;
    }
    setSegmenti(segmentiAllMock);
  }, [selectedProcenaRizika]);

  useEffect(() => {
    if (!isSistematizacijaRadnihMesta) return;
    setRadnaMestaAll(radnaMestaAllMock);
    if (sisRadnihMestaDokumentaId) {
      setDokument((prev) => ({
        ...prev,
        radnoMesto: radnaMestaAllMock.find(
          (rm) => rm.id === sisRadnihMestaDokumentaId
        )
      }));
    }
  }, [isSistematizacijaRadnihMesta, sisRadnihMestaDokumentaId]);

  const onChange = (newValue, field) => {
    setDokument((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFileDocument(file);
    setDokument((prev) => ({ ...prev, nazivDokumenta: getFileName(file) }));
    setIsDodajNoviText(false);
  };

  const handleDodajNovi = () => {
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };

  // --- PRVA POMOC FLOW ---
  const handleSavePrvaPomoc = async () => {
    setIsLoading(true);
    try {
      // Korak 1: kreiraj dokument, dobij id
      const { data: createData } = await axios.post(
        `${baseUrl}/prva_pomoc/create.php`,
        {
          user_id: loggedUser.id,
          api_key: apiKey,
          company_id,
          naziv: dokument.nazivDokumenta,
          broj: dokument.brojDokumenta,
          tip: dokument.segment.dbValue || dokument.segment.name,
          datum_isteka: dokument.datum || null
        }
      );

      if (createData.status !== 201) {
        alert(createData.message || "Greška pri kreiranju dokumenta.");
        setIsLoading(false);
        return;
      }

      const newId = createData.id;

      // Korak 2: uploaduj fajl
      const formData = new FormData();
      formData.append("user_id", loggedUser.id);
      formData.append("api_key", apiKey);
      formData.append("id", newId);
      formData.append("tip_fajla", dokument.scan ? "scan" : "");
      formData.append("file", fileDocument);

      const { data: uploadData } = await axios.post(
        `${baseUrl}/prva_pomoc/upload.php`,
        formData
      );

      if (uploadData.status === 200) {
        setIsDodajNoviText(true);
        setDokument(dokumentEmpty);
        window.dispatchEvent(new Event("prvaPomocAdded"));
        alert("Dokument uspešno sačuvan.");
      } else {
        alert(uploadData.message || "Greška pri uploadu fajla.");
      }
    } catch (e) {
      console.error("Greška:", e);
      alert("Došlo je do greške prilikom povezivanja sa serverom.");
    }
    setIsLoading(false);
  };

  // --- AKT FLOW (originalni) ---
  const handleSaveAkt = async () => {
    const formData = new FormData();
    formData.append("company_id", company_id);
    formData.append("naziv", dokument.nazivDokumenta);
    formData.append("vrsta", dokument.segment.dbValue || dokument.segment.name);
    formData.append("broj_dokumenta", dokument.brojDokumenta);
    formData.append("datum", dokument.datum);
    formData.append("is_scan", dokument.scan ? "1" : "0");
    formData.append("file", fileDocument);

    setIsLoading(true);
    try {
      const { data } = await axios.post(`${baseUrl}/akt/create.php`, formData);

      if (data.status === 200 || data.status === 201) {
        setIsDodajNoviText(true);
        setDokument(dokumentEmpty);
        window.dispatchEvent(new Event("aktAdded"));
        alert("Dokument uspešno sačuvan.");
      } else {
        alert(data.message || "Greška pri čuvanju na serveru.");
      }
    } catch (e) {
      console.error("Greška prilikom slanja:", e);
      alert("Došlo je do greške prilikom povezivanja sa serverom.");
    }
    setIsLoading(false);
  };

  const handleSave = () => {
    if (!dokument.segment || dokument.segment.id === -1) {
      alert("Molimo odaberite segment.");
      return;
    }
    if (isPrvaPomoc) {
      handleSavePrvaPomoc();
    } else {
      handleSaveAkt();
    }
  };

  const handleOdustani = () => {
    setIsGlobalnoDodavanjeDokumenta(false);
  };

  const isDisabledSacuvaj =
    (isSistematizacijaRadnihMesta && !dokument.radnoMesto.name) ||
    !dokument.segment.name ||
    !dokument.nazivDokumenta ||
    !dokument.brojDokumenta ||
    !dokument.datum;

  if (isLoading) return <FullScreenLoader />;

  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "20px",
          alignItems: "flex-end"
        }}
      >
        <CustomSelect
          label={dictionary["segment"]}
          allValues={segmenti}
          selectedValue={dokument.segment}
          onSelectChange={(value) => onChange(value, "segment")}
        />
        {isSistematizacijaRadnihMesta && (
          <CustomSelect
            label={dictionary["radnoMesto"]}
            allValues={radnaMestaAll}
            selectedValue={dokument.radnoMesto}
            onSelectChange={(value) => onChange(value, "radnoMesto")}
          />
        )}
        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px"
            }}
          >
            {dictionary["nazivDokumenta"]}
          </div>
          <input
            value={dokument.nazivDokumenta}
            onChange={(e) => onChange(e.target.value, "nazivDokumenta")}
            style={{ height: "40px", padding: "10px", fontSize: "16px" }}
          />
        </div>
        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px"
            }}
          >
            {dictionary["brojDokumenta"]}
          </div>
          <input
            value={dokument.brojDokumenta}
            onChange={(e) => onChange(e.target.value, "brojDokumenta")}
            style={{ height: "40px", padding: "10px", fontSize: "16px" }}
          />
        </div>
        <div>
          <CustomCalendarInput
            label={dictionary["datum"]}
            value={dokument.datum}
            onChange={(value) => onChange(value, "datum")}
          />
        </div>
        <div>
          <div>
            <img src={scanImg} style={{ width: "30px" }} alt="scan" />
          </div>
          <input
            type="checkbox"
            checked={dokument.scan}
            onChange={(e) => onChange(e.target.checked, "scan")}
            style={{ height: "30px", width: "30px" }}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px"
        }}
      >
        <div onClick={handleOdustani}>
          <Button activation={true} style={styles.button}>
            {dictionary["odustani"]}
          </Button>
        </div>
        <div
          onClick={
            isDodajNoviText
              ? handleDodajNovi
              : isDisabledSacuvaj
                ? undefined
                : handleSave
          }
          style={{ opacity: !isDodajNoviText && isDisabledSacuvaj ? 0.5 : 1 }}
        >
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileInputChange}
          />
          <Button
            isDisabled={!isDodajNoviText && isDisabledSacuvaj}
            activation={true}
            style={styles.button}
          >
            {isDodajNoviText
              ? `+ ${dictionary["dodajNovi"]}`
              : dictionary["sacuvaj"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ProcenaRizikaForm;